/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ClientActivityResults } from '../models/ClientActivityResults';
import type { TrackClientActivityRequest } from '../models/TrackClientActivityRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class LogClientActivityService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Persist one or more client activity events for the current user.
     * Anonymous callers may only submit PageView events and approved Activity details
     * for their origin-mapped sys org.
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public track(
        requestBody?: TrackClientActivityRequest,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/logging/LogClientActivity/Track',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get client activity events for sys orgs the current user can access.
     * @param sysOrgGuid Optional filter for a specific sys org. Super admins may specify any sys org, while non-super-admins may only specify sys orgs they have access to.
     * @param dateFrom Optional filter for events on or after this date.
     * @param dateTo Optional filter for events on or before this date.
     * @param loginAccount Optional filter for events associated with a specific login account GUID or name or session ID.
     * If a GUID is provided, equivalent login accounts will also be included.
     * If a name is provided, matching login accounts will be included.
     * If a 32-character string is provided, it will be treated as a session ID and matched against the SessionId field.
     * @param searchPhrase Optional filter for events where the RouteName or Detail contains this phrase.
     * @param pageNumber The page number to retrieve (1-based).
     * @param pageSize The number of events per page (default 50, max 200).
     * @returns ClientActivityResults OK
     * @throws ApiError
     */
    public getAllClientActivities(
        sysOrgGuid?: string,
        dateFrom?: string,
        dateTo?: string,
        loginAccount?: string,
        searchPhrase?: string,
        pageNumber?: number,
        pageSize: number = 50,
    ): CancelablePromise<ClientActivityResults> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/logging/LogClientActivity/GetAllClientActivities',
            query: {
                'sysOrgGuid': sysOrgGuid,
                'dateFrom': dateFrom,
                'dateTo': dateTo,
                'loginAccount': loginAccount,
                'searchPhrase': searchPhrase,
                'pageNumber': pageNumber,
                'pageSize': pageSize,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
